export const htmlUtils = new (class HtmlUtils {
    setScrollBehaviour(scrollBehaviour) {
        const htmlElement = document.getElementsByTagName("html")[0];
        htmlElement.style.scrollBehavior = scrollBehaviour;
    }
})();
